'use client';

export { SubjectsWidgetComponent as SubjectsWidgetComponentB } from './SubjectsWidgetComponent';
